export default "__VITE_ASSET__vh3P7oLg__"